import React, { useEffect, useRef } from "react";
import ReactSignatureCanvas from "react-signature-canvas";
import styles from "./IR330C.module.scss";
import Button from "react-bootstrap/Button";
const IR330CDeclaration = (props) => {
  const { setSignatureData, setDateData, day1, day2, month1, month2, year3, year4 } = props;
  const signatureRef = useRef(null);
  const day1Ref = useRef(null);
  const day2Ref = useRef(null);
  const month1Ref = useRef(null);
  const month2Ref = useRef(null);

  const year3Ref = useRef(null);
  const year4Ref = useRef(null);
  useEffect(() => {
    if (props.signature === "" && signatureRef.current) {
      signatureRef.current.clear();
    }
  }, [props.signature]);
  const clearSignature = () => {
    signatureRef.current.clear();
    setSignatureData("");
  };

  const onDateChange = (e) => {
    let data = e.target.value;
    if (isNaN(Number(data))) {
      return;
    }
    switch (e.target.name) {
      case "day1":
        day2Ref.current.focus();
        break;
      case "day2":
        month1Ref.current.focus();
        break;
      case "month1":
        month2Ref.current.focus();
        break;
      case "month2":
        year3Ref.current.focus();
        break;
      case "year3":
        year4Ref.current.focus();
        break;
      default:
        break;
    }
    setDateData({ name: e.target.name, value: data });
  };

  return (
    <div className={styles.irdInnerDetails}>
      <div className="row">
        <div className="col-sm-12 col-md-8 col-lg-6">
          <div className={styles.irdInnerDetailsTitle + " mb-2"}>
            3 <span className="pl-3">Declaration</span>
          </div>{" "}
        </div>
      </div>

      <div className={styles.rowMargin + " row"}>
        <div className="col-sm-12 col-md-12 col-lg-12">
          <p className="mb-1">
            <strong>Signature</strong>
          </p>
        </div>
      </div>

      <div className={styles.rowMargin + " row"}>
        <div className=" col-sm-12 col-md-10 col-lg-9">
          <div className="digital-signed">
            <div className="name" style={{ width: "100%" }}>
              <ReactSignatureCanvas
                penColor="black"
                backgroundColor="white"
                // canvasProps={{ height: 90, width: 750 }}
                ref={signatureRef}
                onEnd={() => {
                  const imageData = signatureRef.current.getTrimmedCanvas().toDataURL("image/png");
                  setSignatureData(imageData);
                }}
              />
            </div>
          </div>
          <Button
            variant="outline-secondary"
            className="clear-signature-irr3"
            onClick={clearSignature}
            style={{ cursor: "pointer" }}>
            Clear signature
          </Button>
        </div>

        <div className="col-xs-7 col-sm-12 col-md-2 col-lg-3">
          <div className="eightdigit-number-inputbox">
            <div className="inputbox">
              <input
                maxLength="1"
                type="text"
                placeholder="D"
                id="day1"
                name="day1"
                className="w-100"
                ref={day1Ref}
                value={day1}
                onChange={onDateChange}
                required={true}
              />
            </div>
            <div className="inputbox sm-mr-1" style={{ borderRight: "2px solid #2b557f" }}>
              <input
                maxLength="1"
                type="text"
                placeholder="D"
                id="day2"
                name="day2"
                className="w-100"
                ref={day2Ref}
                value={day2}
                onChange={onDateChange}
                required={true}
              />
            </div>
            <div className="inputbox bg-color">
              <input
                maxLength="1"
                type="text"
                placeholder="M"
                id="month1"
                name="month1"
                className="w-100"
                ref={month1Ref}
                value={month1}
                onChange={onDateChange}
                required={true}
              />
            </div>
            <div className="inputbox sm-mr-1" style={{ borderRight: "2px solid #2b557f" }}>
              <input
                maxLength="1"
                type="text"
                placeholder="M"
                id="month2"
                name="month2"
                className="w-100"
                ref={month2Ref}
                value={month2}
                onChange={onDateChange}
                required={true}
              />
            </div>
            <div className="inputbox bg-color">
              <input
                maxLength="1"
                type="text"
                placeholder="Y"
                id="year1"
                name="year1"
                className="w-100"
                value="2"
                disabled
              />
            </div>
            <div className="inputbox">
              <input
                maxLength="1"
                type="text"
                placeholder="Y"
                id="year2"
                name="year2"
                className="w-100"
                value="0"
                disabled
              />
            </div>
            <div className="inputbox">
              <input
                maxLength="1"
                type="text"
                placeholder="Y"
                id="year3"
                name="year3"
                className="w-100"
                ref={year3Ref}
                value={year3}
                onChange={onDateChange}
                required={true}
              />
            </div>
            <div className="inputbox">
              <input
                maxLength="1"
                type="text"
                placeholder="Y"
                id="year4"
                name="year4"
                className="w-100"
                ref={year4Ref}
                value={year4}
                onChange={onDateChange}
                required={true}
              />
            </div>
          </div>
          <div className="eightdigit-number-inputbox day-month-year">
            <div className="inputbox day_ir330">Day</div>
            <div className="inputbox month_ir330 pl-30">Month</div>
            <div className="inputbox year_ir330 pl-85">Year</div>
          </div>
        </div>
      </div>

      <div className="row">
        <div className="col-sm-12 col-md-12 col-lg-12">
          <p className=""></p>
        </div>
      </div>
    </div>
  );
};

export default IR330CDeclaration;
